import React from "react";
import { Image } from "react-bootstrap";

const TableSearchField = ({
  value,
  onChange,
  placeholder = "Search here...",
  className = "",
  maxWidth = "300px",
}) => {
  return (
    <div
      className={`table-search-field ${className}`.trim()}
      style={{ maxWidth }}
    >
      <Image
        src="/assets/images/search-icon.svg"
        alt=""
        width={16}
        height={16}
        className="table-search-field__icon"
        aria-hidden="true"
      />
      <input
        type="search"
        placeholder={placeholder}
        className="table-search-field__input"
        value={value}
        onChange={onChange}
        aria-label={placeholder}
      />
    </div>
  );
};

export default TableSearchField;
